import { Star } from 'lucide-react'

export function StarCounter({ count, pulse = false }: { count: number; pulse?: boolean }) {
  return (
    <div className={`inline-flex min-h-12 items-center gap-2 rounded-2xl bg-[#fff6d4] px-4 py-2 font-extrabold text-ink ${pulse ? 'animate-star-pop' : ''}`} aria-label={`${count} 颗星星`}>
      <Star className="h-6 w-6 fill-sun text-[#d89f19]" aria-hidden="true" />
      <span className="tabular-nums">{count}</span>
    </div>
  )
}
